import { jsx as _jsx } from "react/jsx-runtime";
import { formatDuration } from "@air/utilities";
import { ClipUtils, isPdfRenderedExtension } from "@air/utils-clips";
import { memo } from "react";
export const AssetGalleryCardShortInfo = /*#__PURE__*/ memo((param)=>{
    let { clip } = param;
    var _clip_duration;
    const time = formatDuration((_clip_duration = clip.duration) !== null && _clip_duration !== void 0 ? _clip_duration : 0);
    const transcoded = ClipUtils.isTranscoded(clip.status);
    const videoTime = clip.type === "video" && transcoded && time;
    const value = isPdfRenderedExtension(clip.ext) ? clip.ext.toUpperCase() : videoTime;
    if (!value) {
        return null;
    }
    return /*#__PURE__*/ _jsx("span", {
        className: "block rounded-sm bg-pigeon-700 px-1 text-10 font-medium text-white",
        style: {
            letterSpacing: isPdfRenderedExtension(clip.ext) ? 1.44 : 0.32,
            fontWeight: isPdfRenderedExtension(clip.ext) ? "semibold" : "medium"
        },
        children: value
    });
});
AssetGalleryCardShortInfo.displayName = "AssetGalleryCardShortInfo";
